/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Aggressive_BehaviourInputs */



/**
* | output |
* | --- |
* | "Aggressive Behaviour" |
*
* @param {Sanction_Sub_Aggressive_BehaviourInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_aggressive_behaviour = /** @type {((inputs?: Sanction_Sub_Aggressive_BehaviourInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Aggressive_BehaviourInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comportement Agressif")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comportamiento Agresivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comportamento Agressivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comportamento Aggressivo")
	return /** @type {LocalizedString} */ ("Aggressive Behaviour")
});